// Root actions
// import axios from 'axios'
import { axios } from '@/plugins/axios'

const loginUrl = process.env.VUE_APP_API_URL + 'login'
const refreshUrl = process.env.VUE_APP_API_URL + 'refresh'

export default {
  // Set flag in state
  setIsLoggedFlag ({ commit }, value) {
    commit('SET_IS_LOGGED_FLAG', value)
  },

  populateAccessToken ({ commit, dispatch, getters }) {
    commit('POPULATE_ACCESS_TOKEN')

    if (getters.getAccessToken) {
      dispatch('fetchUser')
    }
  },

  async register ({ commit, dispatch }, payload) {
    dispatch('loadingModalActive', true)
    let success = null
    try {
      const response = await axios.post(payload.url, payload.data)
        localStorage.setItem('accessToken', response.data.data.access_token)
        commit('LOGIN', response.data.data)
        commit('SET_IS_LOGGED_FLAG', 1)
        commit('SET_SURVEY_SLUG', payload.survey_slug)
        success = response
      } catch(error) {
        dispatch('openErrorsModal', {
          content: error.response.data.errors
        })
      } finally {
        dispatch('loadingModalActive', false)
      }
      return success
  },

  async login ({ commit, dispatch }, payload) {
    dispatch('loadingModalActive', true)
    let success = null

    try {
        const response = await axios.post(payload.url, payload.data)
        localStorage.setItem('accessToken', response.data.access_token)
        commit('LOGIN', response.data)
        commit('SET_IS_LOGGED_FLAG', 1)
        commit('SET_USER', response.data.user)
        commit('SET_SURVEY_SLUG', payload.survey_slug)
        success = response
      } catch(error) {
        dispatch('openErrorsModal', {
          content: error.response.data.error
        })
      } finally {
        dispatch('loadingModalActive', false)
      }

    return success
  },

  logout ({ commit }) {
    commit('LOGOUT')
    commit('SET_IS_LOGGED_FLAG', 0)
    commit('POPULATE_AUTH_AT_STATE')
    commit('POPULATE_USER_AT_STATE')
  },

  async fetchUser ({ commit }) {
    return axios
      .get('me')
      .then(response => {
        commit('SET_USER', response.data.data)
      })
  },

  // Attach auth header to axios
  attachAuthHeader ({ getters }) {
    axios.interceptors.request.use(
      function (config) {
        const accessToken = getters.getAccessToken
        if (accessToken && config.url !== refreshUrl) {
          config.headers['Authorization'] = 'Bearer ' + accessToken
        }
        return config
      },
      function (error) {
        return Promise.reject(error)
      }
    )
  },

  // Survey refresh
  refreshRequest ({ getters }) {
    return axios.post(refreshUrl, { 'refresh_token': getters.getRefreshToken })
  },

  // Reset access object for future uses
  resetAccessRequest ({ commit }) {
    return commit('REFRESH_REQUEST', null)
  },

  refreshAccessToken ({ state, commit, dispatch }) {
    if (!state.refreshRequest) {
      // Only once survey refresh
      commit('REFRESH_REQUEST', dispatch('refreshRequest'))
      return state.refreshRequest.then(response => {
        dispatch('resetAccessRequest')
        return response
      })
    }
    return state.refreshRequest
  },

  // Attach refreshing token functionality
  attachAuthRefresh ({ dispatch, commit }, opts) {
    // const axios = opts.axios || axios

    axios.interceptors.response.use(
      function (response) {
        return response
      },
      function (error) {
        if (error.response !== undefined && error.response.status === 401) {
          const originalRequest = error.config

          if (originalRequest.url === loginUrl) {
            // It's error on login PAGE!
            return Promise.reject(error)
          } else if (originalRequest.url !== refreshUrl) {
            // Check if it's retried request
            if (error.config && !error.config._isRetry && 1) {
              return dispatch('refreshAccessToken')
                .then(response => {
                  // Mark as a retry request to call once
                  error.config._isRetry = true
                  // Remember new access token and populate store
                  commit('LOGIN', response.data)
                  commit('POPULATE_AUTH_AT_STATE')
                  // Add refreshed access token to retried request
                  error.config.headers['Authorization'] =
                                        'Bearer ' + response.data.access_token
                  // Retry request
                  return axios(error.config)
                })
                .catch(() => {
                  dispatch('logout')
                  dispatch('setLoginLayout')
                  // Reject unauthorized requests
                  return Promise.reject(error)
                })
            }
            // Reject unauthorized requests
            return Promise.reject(error)
          }
        }
        // Reject all requests with not auth status
        return Promise.reject(error)
      }
    )
  },
  loadingModalActive ({ commit }, value) {
    commit('LOADING_MODAL_ACTIVE', value)
  },
  openErrorsModal ({ commit }, payload) {
    commit('OPEN_ERRORS_MODAL', payload)
  },
  closeErrorsModal ({ commit }) {
    commit('CLOSE_ERRORS_MODAL')
  },

}
